export default () => {
  $(".js-categories-select").on("click", function () {
    $(this).toggleClass("is-open");
  });
  $(document).on("click", function (e) {
    if ($(e.target).is(".js-categories-select") === false) {
      $(".js-categories-select").removeClass("is-open");
    }
  });
}